/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Purushottam Yadav Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Purushottam Yadav Portfolio",
    type: "website",
    url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Purushottam Yadav",
  logo_name: "Purushottam Yadav",
  nickname: "purushyb",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
  portfolio_repository: "https://github.com/purushyb/masterPortfolio",
  githubProfile: "https://github.com/purushyb",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/purushyb",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/purushyb/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:purushottamyadavbattula@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Mobile App Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Developing secure and stable Android apps for 1M+ users (Kotlin, Jetpack Compose)",
        "⚡ Building cross-platform mobile applications and SDKs using Flutter & Dart",
        "⚡ Expert in performance optimization, reducing crash rates, and SDK footprint by 50%",
        "⚡ Experience in iOS development using Swift and SwiftUI",
      ],
      softwareSkills: [
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "logos-kotlin",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "logos-android-icon",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: { color: "#02569B" },
        },
        {
          skillName: "Swift",
          fontAwesomeClassname: "logos-swift",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "logos-dart",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
    {
      title: "Machine Learning & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing Deep Learning models using TensorFlow and Keras",
        "⚡ Experience with Natural Language Processing (NLP) and Computer Vision (CNN)",
        "⚡ Proficient in data analysis and manipulation using Numpy and Pandas",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: { color: "#150458" },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Deploying applications using Docker containers",
        "⚡ Working with Google Cloud Platform (GCP) for core infrastructure",
        "⚡ Integrating security scans (SNYK, Fortify) into CI/CD pipelines",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: { color: "#4285F4" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: { color: "#FFCA28" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "JNTUA College of Engineering, Pulivendula",
      subtitle: "B.Tech. in Computer Science and Engineering",
      logo_path: "jntua_logo.png",
      alt_name: "JNTUA",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ Studied Core Computer Science subjects like Data Structures, Algorithms, DBMS, and OS.",
        "⚡ Specialized in Mobile Computing and Software Engineering principles.",
      ],
      website_link: "https://www.jntuacep.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Flutter Development Bootcamp",
      subtitle: "App Brewery",
      logo_path: "flutter_logo.png",
      certificate_link: "https://www.appbrewery.co/courses/548873/certificate",
      alt_name: "App Brewery",
      color_code: "#FFFFFF",
    },
    {
      title: "Android TDD Masterclass",
      subtitle: "Udemy",
      logo_path: "android_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-15bb52c0-90f3-415c-bf37-6493256080da/",
      alt_name: "Udemy",
      color_code: "#FFFFFF",
    },
    {
      title: "TensorFlow Developer Specialization",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/4XSRF6RHASMK",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
    },
    {
      title: "Natural Language Processing in TensorFlow",
      subtitle: "DeepLearning.AI / Coursera",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/58LOI7XFCTBD",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
    },
    {
      title: "Convolutional Neural Networks in TensorFlow",
      subtitle: "DeepLearning.AI / Coursera",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/FUQVV7S5P2PH",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
    },
    {
      title: "Sequences, Time Series and Prediction",
      subtitle: "DeepLearning.AI / Coursera",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5RR9GNDTEK26",
      alt_name: "DeepLearning.AI",
      color_code: "#00000099",
    },
    {
      title: "GCP Fundamentals",
      subtitle: "Google Cloud",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/7YG43TSD2EPN",
      alt_name: "Google",
      color_code: "#4285F499",
    },
    {
      title: "GCP Big Data and Machine Learning",
      subtitle: "Google Cloud / Coursera",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/SGME4LYP2VMQ",
      alt_name: "Google",
      color_code: "#4285F499",
    },
    {
      title: "GCP Fundamentals: Core Infrastructure",
      subtitle: "Google Cloud / Coursera",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/7YG43TSD2EPN",
      alt_name: "Google",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Professional Journey",
  description:
    "Senior Software Engineer with a focus on high- impact mobile solutions in Fintech and AI Automation.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Senior Software Engineer",
          company: "Westpac",
          company_url: "https://www.westpac.com.au",
          logo_path: "westpac_logo.png",
          duration: "Feb 2023 - Present",
          location: "Sydney, Australia",
          description:
            "Leading security enhancements and performance optimization for Westpac's flagship Android app (1M+ users). Reduced crash rate to 0.4% and improved performance by 4x through architectural improvements.",
          color: "#E51937",
        },
        {
          title: "Software Development Engineer",
          company: "Yellow.ai",
          company_url: "https://yellow.ai/",
          logo_path: "yellow_logo.png",
          duration: "Dec 2019 - Dec 2022",
          location: "Bengaluru, India",
          description:
            "Developed hybrid-native SDKs and chatbot interfaces. Reduced SDK size by 50%, enabling 2x business growth through easier partner integrations.",
          color: "#FFD700",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Intern",
          company: "Yellow.ai",
          company_url: "https://yellow.ai/",
          logo_path: "yellow_logo.png",
          location: "Bengaluru, India",
          description:
            "Developed and deployed scalable chatbot interfaces for Tier-1 commercial applications. Researched and implemented AI-driven integrations, focusing on improving natural language responses and system reliability for high-traffic retail platforms.",
          color: "#FFD700",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Founder & Lead Maintainer",
          company: "KarnaForge Community",
          company_url: "https://karnaforge.dev",
          logo_path: "karnaforge_logo.png", // You can use a custom logo or github_logo.png
          duration: "July 2025 - PRESENT",
          location: "Remote",
          description:
            "Founded and spearheading KarnaForge, an open-source organization dedicated to building high-utility mobile tools like Exam Analyzer and Markdown Notes using Flutter. Beyond internal projects, I actively contribute to world-class repositories including TensorFlow, Facebook (Meta), Google, and Uber, focusing on performance optimizations, feature enhancements, and robust technical documentation.",
          color: "#181717",
        },
        {
          title: "Developer Students Club Lead",
          company: "DSC Pulivendula",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Pulivendula, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I focus on engineering scalable solutions using a diverse array of cutting-edge technologies. My expertise lies in developing robust, multi-platform applications that deliver a consistent and intuitive experience by masterfully handling complex offline-online data transitions.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "purush_image.png",
    description:
      "I am available on most of social media accounts. You can message me, I will reply within 24 hours. I can help you with Android, Flutter, iOS, ML, AI, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Sydney, NSW, Australia",
    locality: "Syndney",
    country: "Australia",
    region: "NSW",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
